export var LinkType = /*#__PURE__*/function (LinkType) {
  LinkType["MAIN_ACTION"] = "mainAction";
  LinkType["ENTITY"] = "entity";
  LinkType["PATH"] = "path";
  LinkType["FPN_LINK"] = "fullPageNotifications";
  LinkType["OPEN_IN_NEW_TAB_BUTTON"] = "openInNewTabButton";
  LinkType["OPEN_FULL_COMMENT_THREAD"] = "openFullCommentThread";
  LinkType["OPEN_MAIN_ACTION_FROM_DOCUMENT"] = "openMainActionFromDocument";
  return LinkType;
}({});
export var SloFailureReason = /*#__PURE__*/function (SloFailureReason) {
  SloFailureReason["FETCH_FAILED"] = "fetch-failed";
  SloFailureReason["ADF_RENDER_FAILED"] = "adf-render-failed";
  SloFailureReason["ROOT_ERROR_BOUNDARY"] = "root-error-boundary";
  SloFailureReason["ABORT_TIMEOUT"] = "abort-timeout";
  SloFailureReason["UNKNOWN"] = "unknown";
  return SloFailureReason;
}({});

/* A type for whether a click is cross-product/cross-site.
We don't know if something is cross-site/cross-product if the
original site and product are not provided, so this is encoded
in the unknown data type. */
export var CrossType = /*#__PURE__*/function (CrossType) {
  CrossType["TRUE"] = "true";
  CrossType["FALSE"] = "false";
  CrossType["UNKNOWN"] = "unknown";
  return CrossType;
}({});